import React from 'react';
import { motion } from 'framer-motion';
import { BrainIcon, ShieldIcon, TrendingUpIcon, UsersIcon } from 'lucide-react';
export function BenefitsGrid() {
  const benefits = [{
    icon: <BrainIcon className="w-10 h-10 text-brand-amber" data-id="element-15" />,
    title: 'Tranquilidad y Foco',
    text: 'Competir con más tranquilidad, foco y valentía en los partidos que más pesan.'
  }, {
    icon: <ShieldIcon className="w-10 h-10 text-brand-amber" data-id="element-16" />,
    title: 'Confianza y Resiliencia',
    text: 'Desarrollar confianza real, resiliencia y mejor respuesta al error.'
  }, {
    icon: <TrendingUpIcon className="w-10 h-10 text-brand-amber" data-id="element-17" />,
    title: 'Crecimiento Personal',
    text: 'Transformar la presión en una oportunidad de crecimiento y no en una carga.'
  }, {
    icon: <UsersIcon className="w-10 h-10 text-brand-amber" data-id="element-18" />,
    title: 'Apoyo Familiar',
    text: 'Aprender como familia a sostener mejor su proceso deportivo y emocional.'
  }];
  return <section className="py-16 md:py-20 bg-brand-cream" data-id="element-19">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-20">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-10 md:mb-16" data-id="element-21">
          <h2 className="text-3xl md:text-4xl font-heading text-brand-slate mb-4" data-id="element-22">
            Con este producto vas a poder:
          </h2>
          <div className="w-24 h-1 bg-brand-amber mx-auto rounded-full" data-id="element-23"></div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-24">
          {benefits.map((benefit, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white p-8 rounded-2xl shadow-soft hover:shadow-lg transition-all duration-300 border border-brand-slate/5 group" data-id="element-25">
              <div className="w-16 h-16 bg-brand-cream-dark rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300" data-id="element-26">
                {benefit.icon}
              </div>
              <h3 className="text-xl font-heading text-brand-slate mb-3" data-id="element-27">
                {benefit.title}
              </h3>
              <p className="text-brand-slate-light leading-relaxed" data-id="element-28">
                {benefit.text}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}